import * as React from 'react';
import styled from 'foundations-theming/utils';
import partial from 'transmute/partial';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UIList from 'UIComponents/list/UIList';
import UIPopover from 'UIComponents/tooltip/UIPopover';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import UITruncateString from 'UIComponents/text/UITruncateString';
import { UpIcon, DownIcon } from 'foundations-assets';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledWrapper = styled.div.withConfig({
  displayName: "PreviewBadge__StyledWrapper",
  componentId: "rrs3kv-0"
})(["display:flex;"]);
const StyledBadge = styled.div.withConfig({
  displayName: "PreviewBadge__StyledBadge",
  componentId: "rrs3kv-1"
})(["white-space:nowrap;text-transform:uppercase;padding:2px 10px;font-weight:", ";background-color:", ";color:", ";"], ({
  theme
}) => theme.typography['heading-600'].fontWeight, ({
  use,
  theme
}) => use === 'yes' ? theme.color['fill-positive-hover'] : theme.color['fill-accent-red-hover'], ({
  use,
  theme
}) => use === 'yes' ? theme.color['fill-accent-green-pressed'] : theme.color['text-alert-pressed']);
class PreviewBadge extends React.Component {
  constructor(props) {
    super(props);
    this.handleOptionClick = this.handleOptionClick.bind(this);
    this.state = {
      open: false
    };
  }
  handleOptionClick(option) {
    const {
      onChange,
      value
    } = this.props;
    this.setState({
      open: false
    });
    if (onChange && option.value && option.value !== value) {
      onChange(option.value);
    }
  }
  renderOptions(options) {
    return /*#__PURE__*/_jsx(UIList, {
      className: "m-bottom-4",
      children: options.map((option, index) => /*#__PURE__*/_jsx(UITooltip, {
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "platformTest.badges.branch.disabledTooltip"
        }),
        placement: "left",
        disabled: !option.disabled,
        children: /*#__PURE__*/_jsx(UIButton, {
          use: "link",
          onClick: partial(this.handleOptionClick, option),
          disabled: option.disabled,
          children: /*#__PURE__*/_jsx(UITruncateString, {
            maxWidth: 175,
            children: option.text
          })
        })
      }, index))
    });
  }
  render() {
    const {
      use,
      options,
      children
    } = this.props;
    return /*#__PURE__*/_jsxs(StyledWrapper, {
      children: [/*#__PURE__*/_jsx(StyledBadge, {
        use: use,
        "data-test-id": "test-preview-badge",
        children: children
      }), options && /*#__PURE__*/_jsx(UIPopover, {
        open: this.state.open,
        closeOnOutsideClick: true,
        onOpenChange: evt => this.setState({
          open: evt.target.value
        }),
        placement: "left",
        content: {
          body: this.renderOptions(options)
        },
        children: /*#__PURE__*/_jsx(UIButton, {
          "aria-pressed": this.state.open,
          use: "transparent",
          size: "extra-small",
          onClick: () => this.setState({
            open: !this.state.open
          }),
          children: this.state.open ? /*#__PURE__*/_jsx(UpIcon, {
            color: "icon-core-default"
          }) : /*#__PURE__*/_jsx(DownIcon, {
            color: "icon-core-default"
          })
        })
      })]
    });
  }
}
PreviewBadge.defaultProps = {
  use: 'no'
};
export default PreviewBadge;